import template from './admin-list.html';
import controller from './admin-list.controller';

let adminListComponent = {
  bindings: {},
  template,
  controller
};

export default adminListComponent;



// WEBPACK FOOTER //
// ./client/app/components/admin/admin-list.component.js